// src/context/FilterContext.js
import React, { createContext, useContext, useState, useEffect } from "react";

const FilterContext = createContext();

export function FilterProvider({ children }) {
  const [filters, setFilters] = useState(() => {
    const saved = sessionStorage.getItem("filters");
    return saved
      ? JSON.parse(saved)
      : { stores: [], platforms: [] }; // Overview.js 会自动全选
  });

  // ✔ 刷新保持筛选值
  useEffect(() => {
    sessionStorage.setItem("filters", JSON.stringify(filters));
  }, [filters]);

  return (
    <FilterContext.Provider value={{ filters, setFilters }}>
      {children}
    </FilterContext.Provider>
  );
}

export function useFilters() {
  return useContext(FilterContext);
}
